import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "invoice" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "company-details" }
const _hoisted_4 = { class: "company-info" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "tax-details" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", null, "TAX INVOICE", -1)
const _hoisted_11 = { class: "tax-info" }
const _hoisted_12 = { class: "info" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "bill-header" }, "BILL TO", -1)
const _hoisted_15 = { class: "invoice-details" }
const _hoisted_16 = { class: "section" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "info" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "info" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "info" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "section" }
const _hoisted_25 = { class: "info" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "info" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "section" }
const _hoisted_30 = { class: "info" }
const _hoisted_31 = ["textContent"]
const _hoisted_32 = { class: "info" }
const _hoisted_33 = ["textContent"]
const _hoisted_34 = { border: "1" }
const _hoisted_35 = ["textContent"]
const _hoisted_36 = ["textContent"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { colspan: "5" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "summary-detail-name" }, "Subtotal Ex VAT "),
  /*#__PURE__*/_createElementVNode("div", { class: "summary-detail-name" }, "VAT"),
  /*#__PURE__*/_createElementVNode("div", { class: "summary-detail-name" }, "Subtotal Inc VAT"),
  /*#__PURE__*/_createElementVNode("div", { class: "summary-detail-name" }, "Total")
], -1)
const _hoisted_39 = { colspan: "2" }
const _hoisted_40 = { class: "summary-detail-value" }
const _hoisted_41 = { class: "summary-detail-value" }
const _hoisted_42 = { class: "summary-detail-value" }
const _hoisted_43 = { class: "summary-detail-value" }
const _hoisted_44 = { class: "footer" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("\"Quality Service is our Business\""),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" We Are Not Responsible For Any Goods Returned After 7 Days Of Sale")
], -1)

import moment from "moment";

type Header = {
    text: string,
    value: string
}

type Props = {
    company: string,
    companyAddress: string,
    companyMobile: string,
    companyPhone: string,
    companyEmail: string,
    tin: string,
    customer: string,
    customerAddress: string,
    customerPhone: string,
    customerEmail: string,
    salesRep: string,
    customerOrderRef: string,
    invoiceNo: string,
    invoiceDate: string,
    headers: Header[],
    items: any[],
    grossValue: number,
    vatTotal: number,
    totalAmount: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Invoice',
  props: {
    company: {},
    companyAddress: {},
    companyMobile: {},
    companyPhone: {},
    companyEmail: {},
    tin: {},
    customer: {},
    customerAddress: {},
    customerPhone: {},
    customerEmail: {},
    salesRep: {},
    customerOrderRef: {},
    invoiceNo: {},
    invoiceDate: {},
    headers: {},
    items: {},
    grossValue: {},
    vatTotal: {},
    totalAmount: {}
  },
  setup(__props: any) {

const props = __props;

function momentLocal(date: string) {
    return moment.utc(date).local().format("DD MMMM, YYYY");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.company), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_ctx.companyAddress), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode("Ph: "),
            _createElementVNode("span", null, _toDisplayString(_ctx.companyMobile), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createTextVNode("Fax: "),
            _createElementVNode("span", null, _toDisplayString(_ctx.companyPhone), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode("Email: "),
            _createElementVNode("span", null, _toDisplayString(_ctx.companyEmail), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createTextVNode("T.I.N: "),
            _createElementVNode("span", { innerHTML: _ctx.tin }, null, 8, _hoisted_13)
          ])
        ])
      ])
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", {
          class: "info address",
          innerHTML: _ctx.customer
        }, null, 8, _hoisted_17),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", { innerHTML: _ctx.customerAddress }, null, 8, _hoisted_19)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createTextVNode("Phone: "),
          _createElementVNode("span", { innerHTML: _ctx.customerPhone }, null, 8, _hoisted_21)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createTextVNode("Email: "),
          _createElementVNode("span", { innerHTML: _ctx.customerEmail }, null, 8, _hoisted_23)
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createTextVNode("Sales Person: "),
          _createElementVNode("span", { innerHTML: _ctx.salesRep }, null, 8, _hoisted_26)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createTextVNode("Cust Order Ref: "),
          _createElementVNode("span", { innerHTML: _ctx.customerOrderRef }, null, 8, _hoisted_28)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createTextVNode("Invoice No: "),
          _createElementVNode("span", {
            textContent: _toDisplayString(_ctx.invoiceNo)
          }, null, 8, _hoisted_31)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createTextVNode("Date: "),
          _createElementVNode("span", {
            textContent: _toDisplayString(_ctx.invoiceDate)
          }, null, 8, _hoisted_33)
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_34, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header) => {
          return (_openBlock(), _createElementBlock("th", {
            textContent: _toDisplayString(header.text)
          }, null, 8, _hoisted_35))
        }), 256))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createElementBlock("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header) => {
            return (_openBlock(), _createElementBlock("td", {
              textContent: _toDisplayString(item[header.value])
            }, null, 8, _hoisted_36))
          }), 256))
        ]))
      }), 256)),
      _createElementVNode("tr", null, [
        _hoisted_37,
        _hoisted_38,
        _createElementVNode("td", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, "$" + _toDisplayString(_ctx.grossValue), 1),
          _createElementVNode("div", _hoisted_41, "$" + _toDisplayString(_ctx.vatTotal), 1),
          _createElementVNode("div", _hoisted_42, "$" + _toDisplayString(_ctx.totalAmount), 1),
          _createElementVNode("div", _hoisted_43, "$" + _toDisplayString(_ctx.totalAmount), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", null, "Date Printed: " + _toDisplayString(momentLocal(new Date().toLocaleDateString())), 1),
      _hoisted_45
    ])
  ]))
}
}

})